import React from 'react'
import { ReactComponent as AmexIcon } from '../assets/icons/paymentIcons/amex.svg'
import { ReactComponent as AmexClosedIcon } from '../assets/icons/paymentIcons/amexClosed.svg'
import { ReactComponent as ApplePayIcon } from '../assets/icons/paymentIcons/applePay.svg'
import { ReactComponent as ApplePayClosedIcon } from '../assets/icons/paymentIcons/applePayClosed.svg'
import { ReactComponent as CardDeclinedIcon } from '../assets/icons/paymentIcons/cardDeclined.svg'
import { ReactComponent as CashIcon } from '../assets/icons/paymentIcons/cash.svg'
import { ReactComponent as CashClosedIcon } from '../assets/icons/paymentIcons/cashClosed.svg'
import { ReactComponent as DirectBillIcon } from '../assets/icons/paymentIcons/directBill.svg'
import { ReactComponent as DirectBillClosedIcon } from '../assets/icons/paymentIcons/directBillClosed.svg'
import { ReactComponent as DiscoverIcon } from '../assets/icons/paymentIcons/discover.svg'
import { ReactComponent as DiscoverClosedIcon } from '../assets/icons/paymentIcons/discoverClosed.svg'
import { ReactComponent as GenericCardIcon } from '../assets/icons/paymentIcons/genericCard.svg'
import { ReactComponent as MasterCardIcon } from '../assets/icons/paymentIcons/mastercard.svg'
import { ReactComponent as MasterCardClosedIcon } from '../assets/icons/paymentIcons/mastercardClosed.svg'
import { ReactComponent as MobileWalletIcon } from '../assets/icons/paymentIcons/mobileWallet.svg'
import { ReactComponent as MobileWalletClosedIcon } from '../assets/icons/paymentIcons/mobileWalletClosed.svg'
import { ReactComponent as NoCardIcon } from '../assets/icons/paymentIcons/noCard.svg'
import { ReactComponent as VisaIcon } from '../assets/icons/paymentIcons/visa.svg'
import { ReactComponent as VisaClosedIcon } from '../assets/icons/paymentIcons/visaClosed.svg'
import { ReactComponent as SplitTender } from '../assets/icons/paymentIcons/splitTender.svg'
import { ReactComponent as SplitTenderClosed } from '../assets/icons/paymentIcons/splitTenderClosed.svg'
import { ReactComponent as UnknownCard } from '../assets/icons/paymentIcons/unknownCard.svg'
import { ReactComponent as UnknownCardClosed } from '../assets/icons/paymentIcons/unknownCardClosed.svg'

export const paymentIcons = {
    'American Express': {
        open: <AmexIcon />,
        closed: <AmexClosedIcon />
    },
    'Apple Pay': {
        open: <ApplePayIcon />,
        closed: <ApplePayClosedIcon />
    },
    'Cash': {
        open: <CashIcon />,
        closed: <CashClosedIcon />
    },
    'Payment Pending': {
        open: <NoCardIcon />,
        closed: <NoCardIcon />
    },
    'Discover': {
        open: <DiscoverIcon />,
        closed: <DiscoverClosedIcon />
    },
    'Mastercard': {
        open: <MasterCardIcon />,
        closed: <MasterCardClosedIcon />
    },
    'Mobile Pay': {
        open: <MobileWalletIcon />,
        closed: <MobileWalletClosedIcon />
    },
    'Visa': {
        open: <VisaIcon />,
        closed: <VisaClosedIcon />
    },
    'Card Declined': {
        open: <CardDeclinedIcon />,
        closed: <CardDeclinedIcon />,
    },
    'Generic Card': {
        open: <GenericCardIcon />,
        closed: <GenericCardIcon />,
    },
    'Card Required': {
        open: <NoCardIcon />,
        closed: <NoCardIcon />,
    },
    'Split Tender': {
        open: <SplitTender />,
        closed: <SplitTenderClosed />,
    },
    'Unknown Card': {
        open: <UnknownCard />,
        closed: <UnknownCardClosed />,
    },
}

const lowerCasedPaymentIcons = Object.keys(paymentIcons).reduce((accumulator, key) => {
    return {
        ...accumulator,
        [key.toLowerCase()]: paymentIcons[key],
    }
}, {})

export const resolvePaymentIcon = (cardType) => {
    const lowercasedCardType = cardType?.toLowerCase?.() ?? 'unknown card'
    return lowerCasedPaymentIcons[lowercasedCardType]
}
